module.exports = __webpack_public_path__ + "img/a.4ed756d2.png";